/**
 * AdSense configuration for manual ad units (in-article, display).
 * Client ID is also in public/index.html for Auto ads verification.
 */
export const ADSENSE_CLIENT_ID =
  process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-4555509327431924';

/** Create in AdSense → Ads → By ad unit → In-article ads */
export const ADSENSE_BLOG_IN_ARTICLE_SLOT =
  process.env.REACT_APP_ADSENSE_BLOG_IN_ARTICLE_SLOT || '';

/** Create in AdSense → Ads → By ad unit → Display ads (responsive) */
export const ADSENSE_BLOG_LIST_SLOT =
  process.env.REACT_APP_ADSENSE_BLOG_LIST_SLOT || '';

export const hasManualAdSlots = () =>
  Boolean(ADSENSE_BLOG_IN_ARTICLE_SLOT || ADSENSE_BLOG_LIST_SLOT);
